import './StriveFees.scss';
import Component from './StriveFees';
export default Component;